import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { currentUser, userData } = useAuth();
  const { slug } = useParams();

  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to={`/${slug}/cms/login`} replace />;
  }

  if (requireAdmin && userData?.role !== 'superadmin') {
    // Redirect to dashboard if trying to access admin-only page
    return <Navigate to={`/${slug}/cms/dashboard`} replace />;
  }

  return children;
};

export default ProtectedRoute;
